export default __webpack_public_path__ + "static/media/Customer.c2ff2590.xlsx";